import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';   // 全局引用element-ui ↓
import 'element-ui/lib/theme-chalk/index.css';
import './assets/global.css';
import axios from 'axios';
import VueRouter from 'vue-router'; 
import router from './router';    // 路由
import store from './store';      // vuex

Vue.prototype.$axios=axios;
Vue.prototype.$httpUrl='/api'
Vue.config.productionTip = false
Vue.use(VueRouter);
Vue.use(ElementUI, {size: 'small'});

// 添加axios请求拦截器，自动添加Authorization头
axios.interceptors.request.use(
  config => {
    // 从store中获取token
    const token = store.getters.getToken;
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 添加axios响应拦截器，处理403权限错误
axios.interceptors.response.use(
  response => {
    // 检查响应数据中的code字段
    if (response.data && response.data.code === 403) {
      // 403权限错误，显示具体的错误信息
      const errorMessage = response.data.message || response.data.msg || '权限不足，无法执行此操作';
      console.error('权限错误:', errorMessage);
      
      // 使用Element UI的消息提示
      if (window.Vue && window.Vue.prototype.$message) {
        window.Vue.prototype.$message.error(errorMessage);
      }
      
      // 返回一个被拒绝的Promise，这样组件中的catch会捕获到这个错误
      return Promise.reject({
        response: response,
        message: errorMessage,
        code: 403
      });
    }
    
    // 其他情况正常返回响应
    return response;
  },
  error => {
    // 处理其他类型的错误
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);


new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
